import { jsxs as n, jsx as o, Fragment as d } from "react/jsx-runtime";
import { FormControl as h, FormLabel as F, FormHelperText as x, FormErrorMessage as $ } from "@chakra-ui/react";
import { ErrorMessage as b } from "../ErrorMessage/ErrorMessage.mjs";
const j = ({
  children: m,
  name: a,
  "data-testid": r,
  error: t,
  formHelperText: e,
  hideOptionalLabel: s = !1,
  id: c = a,
  isRequired: i,
  label: l,
  ...p
}) => /* @__PURE__ */ n(
  h,
  {
    isInvalid: !!t,
    id: c,
    isRequired: i,
    "data-testid": r,
    ...p,
    children: [
      l && /* @__PURE__ */ n(F, { requiredIndicator: /* @__PURE__ */ o(d, {}), "data-testid": r && `${r}-label`, children: [
        l,
        " ",
        !i && !s && /* @__PURE__ */ o("span", { className: "label-optional", children: "(optional)" })
      ] }),
      m,
      e && /* @__PURE__ */ o(x, { "data-testid": r && `${r}-helptext`, children: e }),
      t && /* @__PURE__ */ o($, { "data-testid": r && `${r}-error`, mt: { base: 1, md: 2 }, children: /* @__PURE__ */ o(b, { children: t }) })
    ]
  }
);
export {
  j as FormControl
};
